import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { supportsCookies } from "../utils";
/**
 * Does the current browser support cookies?
 */

var preDecisionGatewaySupportsCookies = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var supportsCookiesName;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            supportsCookiesName = _ref.supportsCookiesName;
            return _context.abrupt("return", supportsCookies(supportsCookiesName) ? false : "essentials");

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function preDecisionGatewaySupportsCookies(_x) {
    return _ref2.apply(this, arguments);
  };
}();

export { preDecisionGatewaySupportsCookies };